module.exports = __webpack_public_path__ + "img/czzn_044.060c2a17.png";